import { AxiosError } from "axios";
import { ReactNode, useRef } from "react";
import { DefaultOptions, QueryClient, QueryClientProvider } from "react-query";

export function isAxiosError(err: any): err is AxiosError {
    return err && typeof err === "object" && "response" in err;
}

export const makeQueryClient = () => {
    const defaultOptions: DefaultOptions = {
        queries: {
            staleTime: Infinity,
            retry: (_times, error) => {
                if (
                    isAxiosError(error) &&
                    (error.response?.status === 403 ||
                        error.response?.status === 401 ||
                        error.response?.status === 404)
                ) {
                    return false;
                }
                return true;
            },
        },
    };

    return new QueryClient({
        defaultOptions,
    });
};

export const INVALIDATE_CACHE_FLAG = "invalidate_cache_after_magic_link";

interface Props {
    children?: ReactNode;
}

export default function TestboxQueryClientProvider({ children }: Props) {
    const shouldInvalidate =
        sessionStorage.getItem(INVALIDATE_CACHE_FLAG) === "true";
    if (shouldInvalidate) {
        sessionStorage.removeItem(INVALIDATE_CACHE_FLAG);
    }

    const queryClient = useRef(makeQueryClient());

    // Create fresh QueryClient if flag was set (after magic link auth)
    if (shouldInvalidate && queryClient.current) {
        queryClient.current = makeQueryClient();
    }

    return (
        <QueryClientProvider client={queryClient.current}>
            {children}
        </QueryClientProvider>
    );
}
